/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid, Header } from 'nallian-shared-ui/lib/components';

export const HeaderDetailTitle = styled.div`
  font-weight: 300;
  font-size: 0.75em;
  text-transform: uppercase;
`;

export const HeaderGrid = styled(Grid)`
  &.ui.grid {
    margin: -1rem -1rem 1rem;
    border-bottom: 1px solid #ccc;
    overflow: hidden;
  }
`;

export const HeaderColumn = styled(({ last, ...props }) => <Grid.Column {...props} />)`
  .ui.grid > &.column:not(.row) {
    padding: 1rem;
    margin: 0;
    border: solid #ccc;
    border-width: 0 0 1px;
    ${props =>
      props.last &&
      `
        border: 0;
      `};
  }
`;

const HeaderDetail = ({ title, content, children, ...props }) => (
  <Grid.Column {...props}>
    {title && <HeaderDetailTitle>{title}</HeaderDetailTitle>}
    {content && (
      <Header size="medium" margin="0">
        {content}
      </Header>
    )}
    {children}
  </Grid.Column>
);

HeaderDetail.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node,
  children: PropTypes.node,
};

HeaderDetail.defaultProps = {
  content: undefined,
  children: undefined,
  title: undefined,
};

export default HeaderDetail;
